import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import EMTable from '../Tables/EMTable';
import { auxActions } from '../../actions/auxActions';

import {
  Paper,
  Modal,
  CircularProgress,
  withStyles,
} from '@material-ui/core';

import translate from '../../locales';
import { APP_CLAIMS, pageModes, styleWithCommonClasses } from '../../_constants/emparkConstants';
import TitleToolbar from '../Forms/TitleToolbar';
import CellTable from '../Tables/CellTable';
import ErrorMessage from '../ErrorMessage';
import Unauthorized from '../Unauthorized';

const __t = translate;

const styles = styleWithCommonClasses({
  errorText: {
    marginTop: '20px'
  }
});

class DaysPage extends React.Component {
  constructor(props) {
    super(props);

    this.handleSaveDays = this.handleSaveDays.bind(this);
  }

  componentDidMount() {
    this.props.changeMode(pageModes.list);
    this.props.fetchDays();
  }

  render() {
    const { days, loading } = this.props;

    const rowsDaysTable = [
      { id: 'val', align: 'center', disablePadding: false, label: __t('value') },
    ];

    if (this.props.mode === pageModes.list)
      return (
        <div className={this.props.classes.root} style={{ height: '100vh' }}>
          <Unauthorized claim={APP_CLAIMS.MENU_AUX_V}>
            <Modal open={loading}>
              <CircularProgress className={this.props.classes.loadingFixedCenter} color="secondary" />
            </Modal>
            <Paper
              className={this.props.classes.paper}
              elevation={0}
            >
              <EMTable
                tableTitle={__t('days')}
                dataSource={days}
                rows={rowsDaysTable}
                onTableEdit={() => this.props.changeMode(pageModes.edit)}
              />
            </Paper>
          </Unauthorized>
        </div>
      )

    return (
      <div className={this.props.classes.root}>
        <Modal className={this.props.classes.loadingFixedCenter} open={loading}>
          <CircularProgress color="secondary" />
        </Modal>
        <Paper
          className={this.props.classes.paper}
          elevation={0}
        >
          <TitleToolbar
            title={__t('days')}
            onSave={this.handleSaveDays}
            onCancel={() => this.props.changeMode(pageModes.list)}
          >
            <CellTable
              refReturnData={(returnData) => { this.tableSubmit = returnData }}
              values={days.map(d => d.val.toString())}
              type="number"
            />
            <ErrorMessage
              className={this.props.classes.errorText}
              error={this.props.error}
            />
          </TitleToolbar>
        </Paper>
      </div>
    )
  }

  /* events */
  handleSaveDays() {
    const values = this.tableSubmit();

    let days = values
      .filter(v => v != '')
      .map((v, i) => ({
        id: i,
        val: Number(v)
      }));

    if (days.length === 0) {
      this.props.setError(__t("error_no_values"))
      return;
    }

    days.sort((a, b) => a.val - b.val);

    this.props.sendDays(days);
  }
}

function mapStateToProps(state) {
  return {
    days: state.auxReducer.days,
    loading: state.auxReducer.loading,
    mode: state.auxReducer.mode,
    error: state.auxReducer.error
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeMode: (mode) => {
      dispatch(auxActions.changeMode(mode));
    },
    fetchDays: () => {
      dispatch(auxActions.fetchDays());
    },
    sendDays: (days) => {
      dispatch(auxActions.sendDays(days))
    },
    setError: (error) => {
      dispatch(auxActions.setError(error))
    }
  }
}

DaysPage.propTypes = {
  days: PropTypes.array,
  loading: PropTypes.bool,
  mode: PropTypes.string,
  error: PropTypes.string,
  changeMode: PropTypes.func,
  fetchDays: PropTypes.func,
  sendDays: PropTypes.func,
  setError: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DaysPage));